const TERMS_PREFIX = '@TERMS';

export const SET = `${TERMS_PREFIX}/SET`;
